import React, { Component } from 'react'
import i18n from 'live/services/i18n'
import typeFn from './decorator'
import Text from './components/text'
import CodeMirror from 'live/components/codemirror/codemirror'
import FormGroup from 'live/components/forms/ui/form-group'
import FormBase from 'live/components/extensions/ui/form'
import styled from 'styled-components'
require('live/components/codemirror/pipes')

const PipesInput = require('live/components/events/ui/console-input')()

class RealtimeType extends Component {
    componentDidMount() {
        $('.CodeMirror').resizable({
            resize: function () {
                $('.CodeMirror').each(function (i, el) {
                    el.CodeMirror.refresh()
                })
            }
        })
    }
    
    render() {
        const { onChangeCode, onChange, validationState, errorsFor, config, handleValidation } = this.props
        const outputParams = config.outputParams || {}
        const { runNowSpan = '' } = outputParams || {}

        return (
            <div>
                <Container>
                    <div className={`form-group has-feedback has-${validationState('config.query')}`}>
                        <label htmlFor="config.query" className="control-label">
                            <span>
                                {' '}
                                {i18n('Query when first run. This query is intended to be the first load.')}
                                <abbr title="required">*</abbr>
                            </span>
                        </label>
                        

                        <PipesInput
                        id="config.query"
                        name="query"
                        minHeight={-Infinity}
                        maxHeight={Infinity}
                        minWidth={-Infinity}
                        maxWidth={Infinity}
                        handles="e, s, se"
                        disableFocus={true}
                        lineNumbers={true}
                        expression={config.query}
                        onChangeExpression={ v => onChangeCode("query",v)}
                        className="pipes-extension-console"
                        />          

                        <FormGroup
                            type="text"
                            label={
                                <span>
                                    {i18n('Span')}
                                    <abbr title="required">*</abbr>
                                </span>
                            }
                            name="config.span"
                            value={config.span}
                            onChange={handleValidation}
                            validationState={validationState('config.span')}
                            hasFeedback
                            help={errorsFor('config.span')}
                        />
                    </div>
                    <div>
                        <label htmlFor="config.realtimeQuery" className="control-label">
                            <span>
                                {' '}
                                {i18n('Real Time Query: this query is intended to keep running.')}
                                <abbr title="required">*</abbr>
                            </span>
                        </label>
                        <PipesInput
                        minHeight={-Infinity}
                        maxHeight={Infinity}
                        minWidth={-Infinity}
                        maxWidth={Infinity}
                        handles="e, s, se"
                        disableFocus={true}
                        lineNumbers={true}
                        expression={config.realtimeQuery}
                        onChangeExpression={v => onChangeCode("realtimeQuery",v)}
                        className="pipes-extension-console"
                        />  
                        
                        <FormGroup
                    type="text"
                    label={
                        <span>
                            {i18n('Realtime query span')}
                            <abbr title="required">*</abbr>
                        </span>
                    }
                    name="config.realtimeQuerySpan"
                    value={config.realtimeQuerySpan}
                    onChange={handleValidation}
                    validationState={validationState('config.realtimeQuerySpan')}
                    hasFeedback
                    help={errorsFor('config.realtimeQuerySpan')}
                />
                    </div>
                    
                </Container>
                
                <FormGroup
                        type="text"
                        label={
                            <span>
                                {i18n('Result key')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.key"
                        value={config.key}
                        onChange={handleValidation}
                        validationState={validationState('config.key')}
                        hasFeedback
                        help={errorsFor('config.key')}
                    />

                    <FormGroup
                        type="text"
                        label={
                            <span>
                                {i18n('Result value')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.value"
                        value={config.value}
                        onChange={handleValidation}
                        validationState={validationState('config.value')}
                        hasFeedback
                        help={errorsFor('config.value')}
                    />
                
            </div>
        )
    }
}

export default typeFn({
    label: 'Realtime Type',
    type: 'realtime',
    properties: ['cron', 'runNowSpan'],
    config: {},
    validations: {}
})(RealtimeType)

const Container = styled.div`
    display: flex;
    gap: 16px;

    @media (max-width: 1000px) {
        flex-direction: column;
    }

    > div {
        flex: 1;
    }
`
